// © Microsoft Corporation. All rights reserved.

/**
 * Browser version operators enum
 */
export enum BrowserVersionOperator {
    "Equals" = "equals",
    "GreaterThan" = "greaterThan",
    "LessThan" = "lessThan",
    "NotEquals" = "notEquals",
    "OneOf" = "oneOf"
}